exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hint-formatting{line-break:auto;margin-bottom:0px}.save-btn-align{align-self:end}.flex-inline-bottom{display:inline-flex;justify-content:flex-end;align-items:flex-end;width:100%;gap:30rem}\n", ""]);

// exports
